import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  min-height: 100dvh;
}

.auth-page {
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  background: #bfc5c8;
  color: #202027;
  box-sizing: border-box;
}

.auth-card {
  width: 100%;
  max-width: 440px;
  padding: 40px;
  border: 1px solid #e6e6ed;
  border-radius: 24px;
  background: white;
  box-shadow: 0 16px 50px rgba(35, 30, 70, 0.05);
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 28px;
  color: #ff5b3b;
  font-size: 24px;
  font-weight: 800;
  letter-spacing: 1px;
}

.brand img {
  display: block;
  flex-shrink: 0;
}

h1 {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -1px;
  margin: 0 0 12px;
}

.description {
  color: #84848f;
  font-size: 14px;
  line-height: 1.7;
  margin-bottom: 28px;
}

.field {
  margin-bottom: 18px;
}

label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
}

input {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #dddde6;
  border-radius: 10px;
  padding: 13px 14px;
  background: #fff;
  font-size: 15px;
}

input:focus {
  outline: 3px solid #fff0eb;
  border-color: #ff5b3b;
}

.hint {
  margin-top: 6px;
  font-size: 12px;
  color: #858590;
}

.password-field {
  position: relative;
}

.password-field input {
  padding-right: 68px;
}

.reveal {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #696278;
  font-size: 12px;
  background: transparent;
  border: 0;
  cursor: pointer;
}

.submit {
  width: 100%;
  padding: 14px;
  border: 0;
  border-radius: 10px;
  background: #ff5b3b;
  color: white;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  margin-top: 6px;
}

.submit:hover {
  background: #e74c2d;
}

button:focus-visible, a:focus-visible {
  outline: 3px solid #ff9d86;
  outline-offset: 3px;
}

button:disabled {
  opacity: 0.6;
  cursor: wait;
}

.error {
  padding: 12px;
  margin-bottom: 16px;
  border-radius: 8px;
  color: #a82d3b;
  background: #fff0f2;
  font-size: 13px;
  line-height: 1.6;
}

.success {
  padding: 12px;
  margin-bottom: 16px;
  border-radius: 8px;
  color: #356548;
  background: #edf8f0;
  font-size: 13px;
}

.switch {
  text-align: center;
  color: #858590;
  font-size: 13px;
  margin: 24px 0 0;
}

a {
  color: #e74c2d;
  font-weight: 600;
  text-decoration: none;
}

@media (max-width: 480px) {
  .auth-page {
    padding: 20px 16px;
  }
  .auth-card {
    padding: 28px 22px;
    border-radius: 18px;
  }
}`],
})
export class PageAccessComponent implements OnInit {
    public username = '';
    public password = '';
    public showPassword = false;
    public busy = false;
    public error = '';
    constructor(@Inject( Service) public service: Service) { }
    public async ngOnInit() {
        await this.service.init();
        if (this.service.auth.status) {
            this.service.href('/dashboard');
        }
        await this.service.render();
    }

    public registered = new URLSearchParams(location.search).get('registered') === '1';
    public async submit() {
        if (this.busy) return;
        this.error = '';
        if (!this.username.trim() || !this.password) {
            this.error = '아이디와 비밀번호를 입력해주세요.';
            return;
        }
        this.busy = true;
        try {
            const res = await wiz.call('login', {username: this.username, password: this.password});
            if (res.code === 200) {
                // 서버 세션을 확인한 후 현재 앱의 인증 상태로 화면을 전환한다.
                // 전체 페이지 재로드는 초기 인증 검사와 화면 이동을 다시 실행한다.
                await this.service.auth.init();
                if (!this.service.auth.status || !this.service.auth.session?.id) {
                    this.error = '로그인 세션을 유지하지 못했습니다. 브라우저의 쿠키 허용 설정을 확인한 뒤 다시 로그인해주세요.';
                    return;
                }
                this.service.href('/dashboard');
                return;
            }
            this.error = res.data?.message || '로그인하지 못했습니다. 입력 내용을 확인해주세요.';
        } catch (e) {
            this.error = '서버에 연결하지 못했습니다. 다시 시도해주세요.';
        } finally {
            this.busy = false;
            await this.service.render();
        }
    }
}

export default PageAccessComponent;